<div
  class="grid w-full grid-cols-[max-content_1fr_max-content_max-content] overflow-x-auto overflow-y-hidden rounded-md border border-b-0 border-gray-300 shadow-sm"
>
  @for (row of severityLevelContacts; let index = $index; track index) {
    <div
      class="col-start-1 border-b border-r border-gray-300 px-3 py-2 text-[rgb(42,75,152)]"
      [style.grid-row]="'span ' + severityLevelContactRowSpan(row)"
      [class.bg-[rgba(42,75,152,0.025)]]="index % 2"
      [class.bg-white]="!(index % 2)"
    >
      @if (row.link) {
        <a
          matTooltip="Go to definition"
          class="text-blue-600 underline"
          [innerHTML]="row.severity"
          [fragment]="row.link"
          [routerLink]="[]"
        ></a>
      } @else {
        <span class="text-blue-600" [innerHTML]="row.severity"></span>
      }
    </div>

    @if (row['generalEmail']; as generalEmail) {
      <div
        class="col-start-4 border-b border-gray-300 px-3 py-2 text-[rgb(42,75,152)]"
        [style.grid-row]="'span ' + severityLevelContactRowSpan(row)"
        [class.bg-[rgba(42,75,152,0.025)]]="index % 2"
        [class.bg-white]="!(index % 2)"
      >
        <a class="text-blue-600 underline" [href]="'mailto:' + generalEmail">
          {{ generalEmail }}
        </a>
      </div>
    }

    @for (contact of row.contacts; track $index) {
      <div
        class="col-start-2 border-b border-r border-gray-300 px-3 py-2 text-[rgb(42,75,152)]"
        [class.bg-[rgba(42,75,152,0.025)]]="index % 2"
        [class.bg-white]="!(index % 2)"
      >
        {{ contact.name }}
        @if (contact['title']; as title) {
          <span class="opacity-70"> ({{ title }}) </span>
        }
      </div>

      <div
        class="col-start-3 flex flex-col gap-2 border-b border-r border-gray-300 px-3 py-2 text-[rgb(42,75,152)]"
        [class.bg-[rgba(42,75,152,0.025)]]="index % 2"
        [class.bg-white]="!(index % 2)"
      >
        @for (phone of contact.phones; track $index) {
          <div
            class="flex gap-2"
            [matTooltip]="phone.type === 'CEL' ? 'Cellphone' : 'Office'"
          >
            <span class="inline-block h-4 w-4">
              <mat-icon class="scale-75 opacity-75">
                {{ phone.type === 'CEL' ? 'smartphone' : 'phonelink' }}
              </mat-icon>
            </span>
            <a
              class="text-blue-600 underline"
              [href]="'tel:' + phone.number.split(' ').join('')"
            >
              {{ phone.number }}
            </a>
          </div>
        }
      </div>

      @if (!row['generalEmail']) {
        <div
          class="col-start-4 border-b border-gray-300 px-3 py-2"
          [class.bg-gray-50]="index % 2"
          [class.bg-transparent]="!(index % 2)"
        >
          @if (contact['email']; as email) {
            <a class="text-blue-600 underline" [href]="'mailto:' + email">
              {{ email }}
            </a>
          } @else {
            &nbsp;
          }
        </div>
      }
    }
  }
</div>
